import { motion } from "framer-motion"
import {ShoppingCart, Instagram} from 'lucide-react'
import { useLang } from "@/context/LanguageContext"

function PinterestIcon({ size = 16, strokeWidth = 1.5 }: { size?: number; strokeWidth?: number }) {
  return (
    <svg width={size} height={size} viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth={strokeWidth} strokeLinecap="round" strokeLinejoin="round">
      <line x1="12" y1="17" x2="12" y2="22" />
      <path d="M8 22l4-5 4 5" />
      <circle cx="12" cy="10" r="8" />
    </svg>
  )
}

export default function BuySection() {
  const { t } = useLang()

  const primaryAction = {
    titleFr: "Découvrir la collection",
    titleEn: "Discover the collection",
    icon: ShoppingCart,
    url: "#catalogue",
    internal: true,
  }

  const socialLinks = [
    {
      label: "Instagram",
      icon: Instagram,
      url: "https://instagram.com/clipsonbutton",
    },
    {
      label: "Pinterest",
      icon: PinterestIcon,
      url: "https://pinterest.com/clipsonbuttons",
    },
  ]

  return (
    <section id="acheter" className="relative py-20" style={{ backgroundColor: "#1C1917" }}>
      <motion.div
        initial={{ opacity: 0, y: 30 }}
        whileInView={{ opacity: 1, y: 0 }}
        viewport={{ once: true }}
        transition={{ duration: 0.8 }}
        className="max-w-3xl mx-auto px-6 text-center"
      >
        <p className="text-xs tracking-[0.4em] uppercase mb-4" style={{ color: "rgba(225, 89, 63, 0.7)" }}>
          {t("Suivez-nous", "Follow us")}
        </p>
        <h2 className="text-4xl md:text-5xl mb-4" style={{ color: "#F8F2EB", letterSpacing: "4px" }}>
          {t("En savoir plus", "Learn more")}
        </h2>
        <p className="text-sm mb-2" style={{ color: "rgba(248, 242, 235, 0.5)" }}>
          {t("Suivez les coulisses et l'histoire de Clips'On", "Follow the story behind Clips'On")}
        </p>
        <div className="w-16 h-px mx-auto mb-10" style={{ backgroundColor: "rgba(225, 89, 63, 0.4)" }} />

        {/* Primary CTA */}
        <motion.a
          href={primaryAction.url}
          onClick={(e: React.MouseEvent) => {
            e.preventDefault()
            document.querySelector(primaryAction.url)?.scrollIntoView({ behavior: "smooth" })
          }}
          initial={{ opacity: 0, y: 15 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true }}
          transition={{ duration: 0.5 }}
          whileHover={{ scale: 1.02 }}
          whileTap={{ scale: 0.98 }}
          className="inline-flex items-center justify-center gap-3 py-4 px-8 text-xs tracking-[0.2em] uppercase transition-colors duration-300 text-white mb-8"
          style={{ backgroundColor: "#E1593F" }}
          onMouseEnter={e => {
            e.currentTarget.style.backgroundColor = "#C4462E"
          }}
          onMouseLeave={e => {
            e.currentTarget.style.backgroundColor = "#E1593F"
          }}
        >
          <primaryAction.icon size={16} strokeWidth={1.5} />
          {t(primaryAction.titleFr, primaryAction.titleEn)}
        </motion.a>

        {/* Social Links */}
        <div className="flex items-center justify-center gap-6">
          {socialLinks.map((social, i) => (
            <motion.a
              key={social.label}
              href={social.url}
              target="_blank"
              rel="noopener noreferrer"
              initial={{ opacity: 0, y: 15 }}
              whileInView={{ opacity: 1, y: 0 }}
              viewport={{ once: true }}
              transition={{ duration: 0.5, delay: 0.1 + i * 0.1 }}
              whileHover={{ scale: 1.1 }}
              whileTap={{ scale: 0.95 }}
              className="flex flex-col items-center gap-2 transition-colors duration-300"
              style={{ color: "rgba(248, 242, 235, 0.45)" }}
              onMouseEnter={e => {
                e.currentTarget.style.color = "#E1593F"
              }}
              onMouseLeave={e => {
                e.currentTarget.style.color = "rgba(248, 242, 235, 0.45)"
              }}
            >
              <social.icon size={20} strokeWidth={1.5} />
              <span className="text-xs tracking-wider">{social.label}</span>
            </motion.a>
          ))}
        </div>
      </motion.div>
    </section>
  )
}
